import { injectable } from 'inversify'
import type { TableKeyBuilderInterface } from '@/core/tables/types'

@injectable()
export class TableKeyBuilder implements TableKeyBuilderInterface {
  public key(key: string, tableId: string) {
    return [tableId, key].join('')
  }
}
